export default __webpack_public_path__ + "static/media/wallpaper-Elf-03.cef823e5.png";